import { Link } from 'react-router-dom'
import { lockedFeatureLabels, type AdminFeature } from '../../config/featureFlags'

export function FeatureLockedScreen({ feature }: { feature: AdminFeature }) {
  return (
    <main className="records-page">
      <section className="portal-card feature-locked-card" role="status">
        <p className="eyebrow">Admin feature</p>
        <h1>{lockedFeatureLabels[feature]}</h1>
        <p>This feature is temporarily unavailable.</p>
        <p className="muted">The module and its existing data are preserved and can be enabled later.</p>
        <Link className="button button-secondary" to="/admin">Back to dashboard</Link>
      </section>
    </main>
  )
}
